const SCRIPT_HOST =
  process.env.REACT_APP_TELIUM_URI ||
  '//tags.tiqcdn.com/utag/hsbc/uk-cmb-banking-web';

const TAG_ENV = process.env.REACT_APP_TELIUM_DEV_ENVS || 'SDE1,SDE2';
const SCRIPT_NAME = process.env.REACT_APP_SCRIPT_NAME || 'utag.js';

const getEnvTag = (hostScope: string): string => {
  if (hostScope.indexOf('localhost') !== -1) return 'dev';

  const tag: string[] | null = hostScope
    .toUpperCase()
    .match('WWW\\.(.*?)\\-[A-Z]\\.UK');

  return tag
    ? TAG_ENV.split(',').indexOf(tag[0]) !== -1
      ? 'dev'
      : 'qa'
    : 'prod';
};

/**
 * create a script src
 * to load in telium
 */
const getScriptSrc = (): string => {
  const utagEnv = getEnvTag(window.location.host);

  return `${SCRIPT_HOST}/${utagEnv}/${SCRIPT_NAME}`;
};

export default getScriptSrc;
